import React from "react";
import { ShoppingCart, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
interface SolutionsHeaderProps {
  cartItemCount: number;
}
const SolutionsHeader: React.FC<SolutionsHeaderProps> = ({
  cartItemCount
}) => {
  return <div className="flex justify-between items-center mb-8">
      <div>
        <h1 className="text-3xl font-bold text-black">Federal Government Marketplace</h1>
        <p className="text-gray-600 mt-2">
          Browse 326 specialized knowledge bases created by former federal employees
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" className="gap-2">
          <Download className="h-4 w-4" />
          Export
        </Button>
        <Button variant="outline" className="relative gap-2">
          <ShoppingCart className="h-4 w-4" />
          Cart
          {cartItemCount > 0 && <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {cartItemCount}
            </span>}
        </Button>
      </div>
    </div>;
};
export default SolutionsHeader;